export default __webpack_public_path__ + "static/media/AIMA_Logo.48c823ee.png";